module.exports = __webpack_public_path__ + "static/transportation-hero-100-9f57b4d2ac6689ff7f579f7863fee9ab.jpg";